<template>
  <a-layout class="fit">
    <a-layout-header class="" ref="header" style="height: 40px; z-index: 1; line-height: inherit; border-bottom: 1px solid #f0f0f0; box-shadow: none">
      <div class="flex items-center full-height page-toolbar">
        <div class="v-ml-sm">{{ userinfo.realName }}，您好！欢迎来到美丽心灵社区公益基金会用户中心，</div>
        <span class="v-mr-md text-indigo text-italic font-special" ref="time"></span>
        <div class="v-ml-auto flex items-center v-mr-md">
          <span class="toolbar-action" @click="$router.go(-1)">
            <a-icon type="rollback" />返回
          </span>
          <!-- <span class="toolbar-action" @click="reload"><a-icon type="reload" />刷新</span> -->
          <span class="toolbar-action" @click="fullscreen.toggle()">
            <template v-if="fullscreen.isActive">
              <a-icon type="fullscreen-exit" />退出全屏
            </template>
            <template v-else>
              <a-icon type="fullscreen" />全屏
            </template>
          </span>
          <span class="toolbar-action text-indigo" @click="onChangePwd">
            <a-icon type="key" />修改密码
          </span>
          <span class="toolbar-action text-indigo" @click="logout">
            <a-icon type="logout" />退出社区
          </span>
          <!-- <span class="hover-line text-indigo v-mx-sm v-ml-auto" @click="onChangePwd">修改密码</span> -->
          <!-- <span class="hover-line text-indigo v-mr-sm" @click="logout">退出社区</span> -->
        </div>
      </div>
    </a-layout-header>
    <a-layout>
      <a-layout-sider width="100">
        <!-- <a-menu :selected-keys="selectedKeys" :default-open-keys="navMenus.map(menu => menu.path)" mode="inline" theme="dark" @click="onMenuSelect">
          <template v-for="menu in navMenus">
            <a-sub-menu v-if="menu.children && menu.children.length > 0" :key="menu.path">
              <span slot="title">
                <span>{{ menu.name }}</span>
              </span>
              <a-menu-item v-for="submenu in menu.children" :key="submenu.path">{{ submenu.name }}</a-menu-item>
            </a-sub-menu>
            <a-menu-item :key="menu.path" v-else>
              <a-icon :type="menu.icon || 'menu'" />
              <span>{{ menu.name }}</span>
            </a-menu-item>
          </template>
        </a-menu> -->
        <div class="menu-icons" @click="$router.push('/usercenter/todo')" :class="{ active: menu === 'todo' }">
          <div class="menu-icon">
            <a-icon type="schedule" />
          </div>
          <div class="menu-name">我的待办</div>
        </div>
        <div class="menu-icons" @click="$router.push('/usercenter/project')" :class="{ active: menu === 'project' }" v-if="userinfo.busiRoles && userinfo.busiRoles.some(role => ['U01', 'U02', 'U03', 'U04'].includes(role))">
          <div class="menu-icon">
            <a-icon type="project" />
          </div>
          <div class="menu-name">我的项目</div>
        </div>
        <div class="menu-icons" @click="$router.push('/usercenter/meeting')" :class="{ active: menu === 'meeting' }" v-if="userinfo.busiRoles && userinfo.busiRoles.some(role => ['U05', 'U06'].includes(role))">
          <div class="menu-icon">
            <a-icon type="team" />
          </div>
          <div class="menu-name">会议表决</div>
        </div>
        <div class="menu-icons" @click="$router.push('/usercenter/profile')" :class="{ active: menu === 'profile' }">
          <div class="menu-icon">
            <a-icon type="solution" />
          </div>
          <div class="menu-name">用户信息</div>
        </div>
      </a-layout-sider>
      <a-layout-content>
        <div class="page-wrapper page-wrapper-uc" ref="container">
          <router-view />
        </div>
      </a-layout-content>
    </a-layout>
    <!-- 修改密码 -->
    <a-modal :confirmLoading="confirmUpdating" :visible="showPwdModal" :width="400" @cancel="cancelChangePwd" @ok="handleSubmit" centered okText="确认" title="修改密码">
      <a-form autocomplete="off">
        <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
          <span slot="label">
            <i class="required-mark">*</i>
            原密码
          </span>
          <a-input type="password" v-model="oldpwd" ref="oldpwd" autoComplete="new-password" />
        </a-form-item>
        <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
          <span slot="label">
            <i class="required-mark">*</i>
            新密码
          </span>
          <a-input type="password" v-model="newpwd1" ref="newpwd1" autoComplete="new-password" />
        </a-form-item>
        <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
          <span slot="label">
            <i class="required-mark">*</i>
            确认密码
          </span>
          <a-input type="password" v-model="newpwd2" ref="newpwd2" autoComplete="new-password" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal class="modal-preview" :visible="previewVisible" :footer="null" @cancel="cancelPreview" width="auto" :body-style="{ padding: '10px', minWidth: '200px' }">
      <div class="fit text-center">
        <img id="previewImage" class="preview-image" style="max-width: 100%" :src="previewImage" v-if="previewImage" alt="图片"/>
      </div>
    </a-modal>
    <a-modal centered class="modal-preview" :visible="previewVideo" :footer="null" @cancel="cancelPreviewVideo" width="80vw" :body-style="{ padding: '10px', minWidth: '200px', height: '80vh' }">
      <player ref="player" :url="previewVideoUrl" :config="{ videoInit: true }" v-if="previewVideoUrl"/>
    </a-modal>
    <a-modal centered class="modal-preview" :visible="previewPdf" :footer="null" @cancel="cancelPreviewPdf" width="80vw" :body-style="{ padding: '0', minWidth: '200px', height: '95vh' }">
      <iframe name="pdfjsViewer" :src="`pdf/web/viewer.html?file=${previewPdfUrl}`" style="width: 100%; height: 100%; border: none" v-if="previewPdfUrl"></iframe>
    </a-modal>
  </a-layout>
</template>

<script>
import Player from '@/components/player'
import { changePwd, logout } from '@/api/user'
export default {
  name: 'UserCenter',
  components: {
    Player,
  },
  data() {
    return {
      navMenus: [
        {
          name: '合作项目',
          path: '/usercenter/cooperate',
          icon: 'calendar',
        },
        {
          name: '精灵书屋项目',
          path: '/usercenter/b',
          icon: 'appstore',
        },
        {
          name: '螺蛳壳改造',
          path: '/usercenter/c',
          icon: 'file-text',
        },
        {
          name: '会议评估与表决',
          path: '/usercenter/d',
          icon: 'user',
        },
        {
          name: '维护基本信息',
          path: '/usercenter/e',
          icon: 'user',
        },
      ],
      selectedKeys: [],
      menu: null,
      oldpwd: '',
      newpwd1: '',
      newpwd2: '',
      showPwdModal: false,
      confirmUpdating: false,
      previewVisible: false,
      previewImage: null,
      timer: null,
      previewVideo: false,
      previewVideoUrl: null,
      previewPdf: false,
      previewPdfUrl: null,
    }
  },
  watch: {
    $route(route) {
      window.route = this.$route
      this.findSelectedKey()
      // this.routeIdx = this.routes.findIndex((r) => r.path === route.matched[0].path)
    },
  },
  methods: {
    findSelectedKey() {
      // let menu = this.navMenus.find(item => this.$route.fullPath.startsWith(item.path))
      // this.selectedKeys = [menu.path]
      this.menu = this.$route.fullPath.split('/')[2]
    },
    onMenuSelect({ item, key, keyPath }) {
      this.selectedKeys = [key]
      this.$router.push(key)
    },
    logout() {
      logout().then(() => {
        this.$store.dispatch('logout')
      })
      this.$router.push('/login')
    },
    onChangePwd() {
      this.oldpwd = ''
      this.newpwd1 = ''
      this.newpwd2 = ''
      this.showPwdModal = true
    },
    cancelChangePwd() {
      this.showPwdModal = false
    },
    handleSubmit() {
      let vm = this
      this.$message.destroy()
      if (this.oldpwd === '') {
        this.$message.warning('请输入原密码')
        this.$refs.oldpwd.focus()
        return
      }
      if (this.newpwd1 === '') {
        this.$message.warning('请输入新密码')
        this.$refs.newpwd1.focus()
        return
      }
      if (this.newpwd2 === '') {
        this.$message.warning('请输入确认密码')
        this.$refs.newpwd2.focus()
        return
      }
      if (this.newpwd1 !== this.newpwd2) {
        this.$message.warning('新密码与确认密码不一致')
        return
      }
      this.confirmUpdating = true
      let oldPwd = this.oldpwd
      let newPwd = this.newpwd1
      // let oldpwd = CryptoJS.MD5(this.user.username + this.oldpwd).toString()
      // let newpwd = CryptoJS.MD5(this.user.username + this.newpwd1).toString()
      changePwd({
        userId: this.userinfo.id,
        oldPwd,
        newPwd,
      })
        .then(({ data }) => {
          this.confirmUpdating = false
          if (data.success) {
            this.showPwdModal = false
            this.$success({
              title: '提示',
              content: '密码修改成功，请重新登录。',
              onOk: () => {
                vm.$store.dispatch('logout')
                vm.$router.push('/login')
              },
            })
          } else {
            this.$message.warning(data.msg)
          }
        })
        .catch(() => {
          this.$message.warning('服务器响应异常')
          this.confirmUpdating = false
        })
    },
    refreshTime() {
      let vm = this
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        vm.showTime()
      }, 1000)
    },
    showTime() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      var day = date.getDate()
      day = day < 10 ? '0' + day : day
      var week = '日一二三四五六'.charAt(date.getDay())
      var hour = date.getHours()
      hour = hour < 10 ? '0' + hour : hour
      var minute = date.getMinutes()
      minute = minute < 10 ? '0' + minute : minute
      var second = date.getSeconds()
      second = second < 10 ? '0' + second : second
      this.$refs.time.innerHTML = `${year}-${month}-${day} 星期${week} ${hour}:${minute}:${second}`
    },
    handlePreviewImage(file) {
      this.previewImage = file
      this.previewVisible = true
    },
    cancelPreview() {
      this.previewVisible = false
    },
    handlePreviewVideo(url) {
      this.previewVideo = true
      this.previewVideoUrl = url
      this.$nextTick(() => {
        this.$refs.player && this.$refs.player.player.play()
      })
    },
    cancelPreviewVideo() {
      this.previewVideo = false
      this.$nextTick(() => {
        this.$refs.player && this.$refs.player.player.destroy()
        this.previewVideoUrl = null
      })
    },
    handlePreviewPdf(url) {
      this.previewPdf = true
      this.$nextTick(() => {
        this.previewPdfUrl = url
      })
    },
    cancelPreviewPdf() {
      this.previewPdf = false
      this.$nextTick(() => {
        this.previewPdfUrl = null
      })
    },
  },
  mounted() {
    this.findSelectedKey()
    this.refreshTime()
    this.$root.$on('previewImage', this.handlePreviewImage)
    this.$root.$on('previewVideo', this.handlePreviewVideo)
    this.$root.$on('previewPdf', this.handlePreviewPdf)
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
}
</script>
